module.exports = __webpack_public_path__ + "img/detalle-multi2.66cb9c45.png";